import steps from './steps';
import buildConfig from './buildConfig';
import * as configs from './configs';
import { questionsData } from './questionsData';
import useResolvedConfig from '../hooks/useResolvedConfig';
import { useAppStore, useQuestionsStore } from '../store';

// Single source of truth for the survey-engine bootstrap. Called from App's mount
// effect (normal SPA boot) and from the pre-render hydration path BEFORE
// hydrateRoot — so React's very first render already sees the engine in exactly
// the state the captured markup was rendered with. Idempotent: does nothing when
// the steps list is already set up.
//
// Returns the name of the flow's first step.
export default function setupSurvey(): string {
  const appState = useAppStore.getState();
  const configName = appState.config;
  const configToApply = useResolvedConfig(configName);

  if (!appState.list) {
    useQuestionsStore.getState().setup({
      questionsData,
      predifinedAnswers: undefined,
    });

    steps.setup({
      stepsConfig: buildConfig({
        config: configToApply,
        configName,
        age: appState.initialAge,
        role: undefined,
      }),
      currentStep: configToApply[0].name,
      stepsDetails: (configs as unknown as { stepsDetails: Record<string, Record<string, unknown>> }).stepsDetails,
    });
  }

  return configToApply[0].name;
}
